import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons/faCircleExclamation';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the add-ons panel; each part uses its own slice of it */
import styles from './MonthlyAddOns.module.scss';
/* eslint-enable css-modules/no-unused-class */

const ICONS = { info: faCircleInfo, ok: faCheck, error: faCircleExclamation } as const;

interface AddOnAlertProps {
  tone: 'info' | 'ok' | 'error';
  children: React.ReactNode;
}

/** One line of news in the add-ons panel: the next-period note, the saved line, the failed save (design a2, a4, b7). */
const AddOnAlertComponent: React.FC<AddOnAlertProps> = ({ tone, children }) => (
  <div
    className={clsx(
      styles.alert,
      tone === 'info' && styles.alertInfo,
      tone === 'ok' && styles.alertOk,
      tone === 'error' && styles.alertError
    )}
    role={tone === 'error' ? 'alert' : 'status'}
  >
    <FontAwesomeIcon icon={ICONS[tone]} className="mt-1" />
    <span>{children}</span>
  </div>
);

export const AddOnAlert = TypedMemo(AddOnAlertComponent);
